import React, {useState} from 'react';
import "./StandardButton.sass";
import {ReactComponent as CheckBox_default} from "../../../icons/check_box_default.svg";
import {ReactComponent as CheckBox_selected} from "../../../icons/check_box_selected.svg";

const StandardButton = React.forwardRef(({data, id, callback, params, type, className, disabled,style},ref) => {

    const BUTTONTYPE_CHECKBOX = "checkbox";
    const BUTTONTYPE_TOGGLE = "toggle";
    const BUTTONTYPE_PERMACHECK = "permacheck";
    const BUTTONTYPE_RADIO = "radio";
    const [selected, setSelected] = useState(false);
    const [attempted, setAttempted] = useState(false);


    const handleClick = () => {
        if (disabled) return;
        setAttempted(true);
        switch (type) {
            case BUTTONTYPE_TOGGLE:
            case BUTTONTYPE_RADIO:
            case BUTTONTYPE_CHECKBOX:
            case BUTTONTYPE_PERMACHECK:
                toggle();
                break;
            default:
        }
        callback(params);
    }

    const toggle = () => {
        setSelected(!selected);
    }

    const getIcon = () => {
        let icon = null;
        switch (type) {
            case BUTTONTYPE_CHECKBOX:
                if (selected) {
                    icon = <CheckBox_selected className="checkbox"/>;
                } else {
                    icon = <CheckBox_default className="checkbox"/>;
                }
                break;
            case BUTTONTYPE_PERMACHECK:
                if (attempted) {
                    icon = <CheckBox_selected className="checkbox"/>;
                } else {
                    icon = <CheckBox_default className="checkbox"/>;
                }
                break;
            default:
                icon = null;
        }
        return icon
    }

    return <div className={className ? className + (disabled ? " disabled" : "") : (disabled ? "StandardButton disabled" : "StandardButton")}
                style={style||{}}
                onClick={handleClick}>
        {getIcon()}
        {data}
    </div>;
});

export default StandardButton;